import {defineStore} from "pinia";
import Admin from "@/types/Admin";

interface State {
    admin: Admin | null;
}

export const useMainStore = defineStore("main", {
    state: (): State => ({
        admin: null
    })
});